import { render, staticRenderFns } from "./LockscreenComponent.vue?vue&type=template&id=05f1ccf1&scoped=true&"
import script from "./LockscreenComponent.vue?vue&type=script&lang=js&"
export * from "./LockscreenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1ccf1",
  null
  
)

export default component.exports